import { Pipe, PipeTransform } from '@angular/core';
import { bytes } from 'ng2-app/util/bytes';

@Pipe({
  name: 'bytes',
  standalone: false
})
export class BytesPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        const precision = (args && args.precision) || null;
        return bytes(value, precision);
    }

}
